import { render, staticRenderFns } from "./banOpenid.vue?vue&type=template&id=2603fca7&"
import script from "./banOpenid.vue?vue&type=script&lang=js&"
export * from "./banOpenid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2603fca7')) {
      api.createRecord('2603fca7', component.options)
    } else {
      api.reload('2603fca7', component.options)
    }
    module.hot.accept("./banOpenid.vue?vue&type=template&id=2603fca7&", function () {
      api.rerender('2603fca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/components/banOpenid.vue"
export default component.exports